import { createFeatureSelector } from '@ngrx/store';

import * as fromUser from './user.reducer';

export const selectUserState = createFeatureSelector<fromUser.IHestiaUserState>(fromUser.userFeatureKey);
